module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Beach/Nagano_Beach_GFDL_RCP26_End.png";